<template>
  <responsive-modal v-model="visible" title="Integrar RD Station Marketing">
    <div class="tool-modal-rdstation">
      <a
        href="https://www.rdstation.com/produtos/marketing/"
        target="_blank"
        class="integration-link"
      >
        Conheça o RD Station Marketing
        <i class="ph ph-arrow-square-out" />
      </a>
      <snow-input disabled :value="callback_url">
        <snow-button
          size="sm"
          variant="borderless"
          icon="ph ph-copy"
          @click="copyUrl(callback_url)"
        />
      </snow-input>
      <snow-input
        id="client_id"
        label="Client ID"
        :limit="36"
        v-model="form.client_id"
        :errors="errors.client_id"
      />
      <snow-input
        id="client_secret"
        label="Client Secret"
        :limit="32"
        v-model="form.client_secret"
        :errors="errors.client_secret"
      />
      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
        <snow-button
          size="lg"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ...formFields(["client_id", "client_secret"], {
        client_id: "",
        client_secret: ""
      }),
      loading: false,
      visible: false,
      callback_url:
        "https://api.zeuspay.com.br/v1/integrations/rd-station/callback"
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    }
  },
  computed: {
    ...mapState("integration", ["integrationList"]),
    ...mapState("product", ["products"]),
    isValid() {
      return this.form.client_id && this.form.client_secret !== undefined;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    submit() {
      this.loading = true;
      let data = { ...this.form };
      let action = "integration/postIntegration";
      this.$store
        .dispatch(action, data)
        .then(object => {
          this.$message.success("Integração salva");
          this.clear();
          this.loading = false;
          this.visible = false;
        })
        .catch(error => {
          this.$message.error("Erro ao salvar integração");
          this.errors = error.response.data;
          this.loading = false;
        })
        .finally(() => {});
    },
    copyUrl(i) {
      navigator.clipboard.writeText(i);
      this.$message.success("Url copiada.");
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep.fit-scroll-content {
  max-height: unset !important;
}

.tool-modal-rdstation {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
